import axios, {AxiosResponse} from 'axios'
 import { HTTPResponseModel } from '../../../common/models/HTTPResponseModel'

const API_URL = process.env.REACT_APP_API_URL

const LIST_USAGE_FLOOR = `${API_URL}usage/ListUsageFloor`;

export const getListFloor = async (
    data: any,
    onAccessLost?: (message: string) => void,
    onToastOrMessage?: (toastOrMessage: {Message?: string, MessageType?: string, Toast?: string, ToastType?: string}) => void,
): Promise<AxiosResponse<HTTPResponseModel>> => {
    const ares = await axios.get<HTTPResponseModel>(LIST_USAGE_FLOOR, {
        params : data
    })
    if (ares?.data?.Status?.Message && ares?.data?.Status?.MessageType && onToastOrMessage) {
        onToastOrMessage({Message: ares?.data?.Status?.Message, MessageType: ares?.data?.Status?.MessageType})
    }
    if (ares?.data?.Status?.Toast && ares?.data?.Status?.ToastType && onToastOrMessage) {
        onToastOrMessage({Toast: ares?.data?.Status?.Toast, ToastType: ares?.data?.Status?.ToastType})
    }
    if (ares?.data?.Status?.FailureReason === 'AccessToken Expired') {
        return await getListFloor(data, onAccessLost, onToastOrMessage)
    } else if (
        ares?.data?.Status?.FailureReason === 'Incorrect RefreshToken or AccessToken not expired' ||
        ares?.data?.Status?.FailureReason === 'Access lost (connection to another device detected)'
    ) {
        if (onAccessLost) {
            onAccessLost(ares?.data?.Status?.Message)
        }
    }
    return ares
}
